export const ActionTypes = {
  HOTEL_SEARCH_CONTROL_INIT: 'HOTEL_SEARCH_CONTROL_INIT',
  HOTEL_SEARCH_CONTROL_INIT_SUCCESS: 'HOTEL_SEARCH_CONTROL_INIT_SUCCESS',
  HOTEL_SEARCH_CONTROL_GET_INIT_STATE: 'HOTEL_SEARCH_CONTROL_GET_INIT_STATE',
  HOTEL_SEARCH_CONTROL_GET_INIT_STATE_SUCCESS: 'HOTEL_SEARCH_CONTROL_GET_INIT_STATE_SUCCESS',
  HOTEL_SEARCH_CONTROL_SEARCH_INFO_MISSING: 'HOTEL_SEARCH_CONTROL_SEARCH_INFO_MISSING',
  COMBO_SEARCH_SET_EDIT_SEARCH: 'COMBO_SEARCH_SET_EDIT_SEARCH',
  HOTEL_SEARCH_CONTROL_CHANGE_DEPARTURE: 'HOTEL_SEARCH_CONTROL_CHANGE_DEPARTURE',
  HOTEL_SEARCH_CONTROL_GET_DURATIONS: 'HOTEL_SEARCH_CONTROL_GET_DURATIONS',
  HOTEL_SEARCH_CONTROL_GET_DURATIONS_SUCCESS: 'HOTEL_SEARCH_CONTROL_GET_DURATIONS_SUCCESS',
  HOTEL_SEARCH_CONTROL_CHANGE_DURATION: 'HOTEL_SEARCH_CONTROL_CHANGE_DURATION',
  HOTEL_SEARCH_CONTROL_GET_DEPARTURE_DATES: 'HOTEL_SEARCH_CONTROL_GET_DEPARTURE_DATES',
  HOTEL_SEARCH_CONTROL_GET_DEPARTURE_DATES_SUCCESS: 'HOTEL_SEARCH_CONTROL_GET_DEPARTURE_DATES_SUCCESS',
  HOTEL_SEARCH_CONTROL_CHANGE_DATES: 'HOTEL_SEARCH_CONTROL_CHANGE_DATES',
  HOTEL_SEARCH_CONTROL_CHANGE_ROOM_DISTRIBUTION: 'HOTEL_SEARCH_CONTROL_CHANGE_ROOM_DISTRIBUTION',
  HOTEL_SEARCH_CONTROL_SET_SHOW_PRICE_CALENDAR: 'HOTEL_SEARCH_CONTROL_SET_SHOW_PRICE_CALENDAR',
  HOTEL_SEARCH_CONTROL_SET_SHOW_DIRECT_FLIGHTS: 'HOTEL_SEARCH_CONTROL_SET_SHOW_DIRECT_FLIGHTS',
  HOTEL_SEARCH_CONTROL_GET_PRICE_CALENDAR_DATA_SUCCESS: 'HOTEL_SEARCH_CONTROL_GET_PRICE_CALENDAR_DATA_SUCCESS',
  HOTEL_SEARCH_CONTROL_SET_PREVIOUS_DURATION: 'HOTEL_SEARCH_CONTROL_SET_PREVIOUS_DURATION',
};
